import type { ReviewSummaryResponse } from 'src/services/reviews-summary-api/types/ReviewSummaryResponse';
import type { ReviewsSummaryAiSummary } from '../types';

export const adaptReviewSummaryToStore = (
  response: ReviewSummaryResponse,
): ReviewsSummaryAiSummary => ({
  lookbackMonths: response.lookbackMonths ?? null,
  text: response.summary,
});
